import {useMemo} from 'react';

import useIsBannerEnabled from '@/hooks/useIsBannerEnabled';

export const useDynamicDesktopHighlights = (carousels) => {
    const isBannerEnabled = useIsBannerEnabled();

    return useMemo(() => {
        if (!carousels?.length) return;

        const dynamicCarousels = carousels.map((carousel) => {
            const {highlights} = carousel;
            const filtered = highlights.filter((highlight) => isBannerEnabled(highlight?.banner));

            return filtered.length ? {...carousel, highlights: filtered} : null;
        });

        return dynamicCarousels.filter(Boolean);
    }, [carousels, isBannerEnabled]);
};
